<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :message="'Newly created tasks are Daily Tasks by default. Use the Special task type dropdown menu to apply a Project or Policing attribute to the task'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_ext_up(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />

                <div class="w-100 table-responsive defaultproject__table overflow-y--1" v-if="step_codes_update.length">
                    <table class="table">
                        <thead style="background-color: #f1f1f1;">
                            <tr>
                                <!-- <th>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`checkedMultipleUpdate`" type="checkbox" class="custom-control-input" v-model="step_code_multiple_update"/>
                                        <label :for="`checkedMultipleUpdate`" class="custom-control-label ml-2"/>
                                    </span>
                                </th> -->
                                <th v-for="(item, i) in step_table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in step_codes_update" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`stepCodeUpdate${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                        <label :for="`stepCodeUpdate${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td v-html="item.code"/>
                                <td v-html="item.name"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "step_codes_update",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
            step_table_headers: Resources.step_table_headers,
            step_code_multiple_update: false,
        }
    },

    watch:{

        'single_object.step_code_id'(val)
        {
            this.step_codes_update.map((item, i) => {
                item.checked = false
                window.$(`#stepCodeUpdate${i}`).prop('checked', false)
            })

            if(val.length)
            {
                val.forEach( (item) => {

                    let index = this.step_codes_update.findIndex(step => step.id === item)

                    if( index > -1 )
                    {
                        this.step_codes_update[index].checked = true
                        window.$(`#stepCodeUpdate${index}`).prop('checked', true)
                    }
                })
            }
        },

        step_code_multiple_update(val)
        {
            this.step_codes_update.map(item => item.checked = val)
        },
        
        'single_object.special_task_type'(val)
        {
            if(val === '')
            {
                this.single_object.project = false
                this.single_object.policing = false
            }
            else if(val === 1)
            {
                this.single_object.project = true
                this.single_object.policing = false
            }
            else if(val === 2)
            {
                this.single_object.project = false
                this.single_object.policing = true
            }
        },

        // 'single_object.step_code_id'(val)
        // {
        //     this.step_codes_update.map(item => item.checked = false)

        //     if(val.length)
        //     {
        //         val.forEach((item) => {

        //             let search_index = this.step_codes_update.findIndex(step => step.id === item)

        //             if(search_index > -1)
        //             {
        //                 this.step_codes_update[search_index].checked = true
        //             }
        //         })
        //     }
        // }
    },
    
    methods:{

        async form_submit_ext_up(id, index)
        {
            if(this.step_codes_update.length)
            {
                let step_codes_update = this.step_codes_update.filter( item => item.checked )
                
                this.single_object.step_code_id = step_codes_update.length ? step_codes_update.map(item => { return item.id }) : []
            }
            
            await this.form_submit_update(id, index)

            // await this.single_object.step_code_id.splice(0, this.single_object.step_code_id.length)

            // if(this.step_codes.length)
            // {
            //     this.step_code_multiple_update = false
            //     this.step_codes.map(item => item.checked = this.step_code_multiple_update)
            // }
        }

    },

    mounted(){

    }
    
}
</script>